document.querySelectorAll('[data-overview-archive]').forEach(archive => {
  const batchSize = parseInt(archive.dataset.batchSize, 10) || 9;
  const container = archive.parentElement;
  const button = container?.querySelector('[data-overview-load-more]');
  const items = Array.from(archive.querySelectorAll('[data-overview-item]'));
  const filterButtons = Array.from(container?.querySelectorAll('[data-overview-filter]') || []);

  const requestedFilter = new URLSearchParams(window.location.search).get('kategorie');
  const initialFilter = filterButtons.some(btn => btn.dataset.overviewFilter === requestedFilter) ? requestedFilter : 'all';

  let currentFilter = initialFilter;
  let shownCount = batchSize;

  const matches = item => currentFilter === 'all' || (item.dataset.category || '').split(' ').includes(currentFilter);

  const render = () => {
    let matched = 0;
    items.forEach(item => {
      if (matches(item)) {
        item.hidden = matched >= shownCount;
        matched++;
      } else {
        item.hidden = true;
      }
    });
    if (button) button.hidden = shownCount >= matched;
  };

  filterButtons.forEach(filterBtn => {
    filterBtn.addEventListener('click', () => {
      currentFilter = filterBtn.dataset.overviewFilter;
      shownCount = batchSize;
      filterButtons.forEach(other => {
        other.setAttribute('aria-pressed', String(other === filterBtn));
      });
      render();
    });
  });

  button?.addEventListener('click', () => {
    shownCount += batchSize;
    render();
  });

  filterButtons.forEach(filterBtn => {
    filterBtn.setAttribute('aria-pressed', String(filterBtn.dataset.overviewFilter === currentFilter));
  });

  render();
});
